<template>
  <div class="right-chart-1 flex-col">
    <div class="container">
      <!-- 标题-->
      <div class="top">
        <div class="top-title">
          <div class="div-bg tabs1">
            <el-tabs
                v-model="activeName"
                @tab-click="handleClick">
              <el-tab-pane label="全部" name="-1"></el-tab-pane>
              <el-tab-pane label="一年" name="365"></el-tab-pane>
              <el-tab-pane label="半年" name="180"></el-tab-pane>
              <el-tab-pane label="30天" name="30"></el-tab-pane>
              <el-tab-pane label="24小时" name="1"></el-tab-pane>
              <el-tab-pane label="自定义设置" name="cus"></el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
      <right-circle-list :key="kfsl_val" :days="this.kfsl_val"></right-circle-list>
      <div class="center">
        <!-- 标题-->
        <div class="top-title flex-row-c-c">
          <div class="tabs-title flex-row-l-c">
            <img
                src="~@/assets/large/free-icon.png"
                style="width: 27px; height: 27px"
            />
            <div class="tabs-title-dec">疾病收入大盘/7天</div>
          </div>
        </div>
        <rightCenterChart/>
      </div>

      <div class="bottom">
        <!-- 标题-->
        <div class="top-title flex-row-c-c">
          <div class="tabs-title flex-row-l-c">
            <img src="~@/assets/large/tabs-title.png" style="width: 27px; height: 27px"/>
            <div class="tabs-title-dec">贴敷复诊率</div>
          </div>
        </div>

        <right-bar></right-bar>
      </div>
    </div>

  </div>
</template>

<script>
import rightCircleList from "./rightCircleList.vue";
import rightBar from "./rightBar.vue";
import rightCenterChart from "./rightCenterChart.vue";

export default {
  name: "RightableChart",
  components: {
    rightCircleList,
    rightBar,
    rightCenterChart,
  },
  mounted() {
    this.handleClick({"name":this.activeName})
  },
  data() {
    // const rad = 4;
    return {
      activeName: "-1",
      activeName1: "first",
      kfsl_val: "",
    };
  },
  methods: {
    handleClick(e) {
      console.log("e :>> ", e);
      this.kfsl_val = e.name
    },
    handleClick1(e) {
      console.log("e :>> ", e);
    },
  },
};
</script>

<style lang="less" scoped>
.right-chart-1 {
  width: 100%;
  /* 与整页滚动配合：侧栏内容随高度撑开，由页面统一滚动 */
  flex: 0 0 auto;
  height: auto;
  display: flex;
  flex-direction: column;

  .container {
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: visible;
    padding: 0 !important;
    /* 标题条公共样式 */
    .top-title {
      position: relative;
      border: 1px solid rgba(96, 252, 178, 0.4);
      background: url("~@/assets/large/border.png") rgba(96, 252, 178, 0.05);
      background-size: 100% 100%;
      /* 横向少留白，标题条与图表尽量铺满栏宽 */
      padding: 8px 2px;
      box-sizing: border-box;

      .tabs-title {
        width: 100%;

        .tabs-title-dec {
          margin-left: 5px;
          width: 100%;
        }
      }

      .div-bg {
        flex-grow: 1;
        height: 100%;

        .paiming {
          height: 34px;
          background-color: #4a5858;
          border-radius: 4px;
          margin-top: 15px;

          .paiming-top {
            width: 72px;
            height: 34px;
            background: #60fcb2;
            border-radius: 4px;
            font-weight: 600;
            font-size: 18px;
            font-family: YouSheBiaoTiHei;
            color: #0d1014;
            margin-right: 15px;
          }
        }
      }
    }

    /* 顶部 Tab（全部/一年/…）：与左栏「省区开方量」等同一套高度与留白 */
    .top > .top-title {
      height: 52px;
      min-height: 48px;
      padding: 4px 2px;
    }

    /* 「疾病收入大盘/7天」「贴敷复诊率」等：矮标题条 */
    .center > .top-title,
    .bottom > .top-title {
      height: auto;
      min-height: 38px;
      max-height: 46px;
      padding: 4px 2px;
      display: flex;
      align-items: center;

      .tabs-title {
        align-items: center;

        .tabs-title-dec {
          font-size: 15px;
          font-weight: 600;
          line-height: 1.25;
          width: auto;
        }
      }

      img {
        width: 22px !important;
        height: 22px !important;
      }
    }

    .top {
      flex-shrink: 0;
    }

    ::v-deep .rightCircleList {
      flex-shrink: 0;
    }

    /* 中间、底部均为自然高度，不做 max-height / 内部滚动裁切 */
    .center {
      flex: 0 0 auto;
      display: flex;
      flex-direction: column;
      overflow: visible;
    }

    .bottom {
      flex: 0 0 auto;
      flex-shrink: 0;
      overflow: visible;
    }

    .table {
      margin-top: 20px;
    }
  }

  .lc1-details {
    height: 50px;
    font-size: 16px;
    display: flex;
    align-items: center;
    text-indent: 20px;

    span {
      color: #096dd9;
      font-weight: bold;
      font-size: 25px;
      margin-left: 20px;
    }
  }

  .lc2-header {
    padding-left: 10px;
    font-size: 18px;
    color: #fff;
    font-weight: bold;
  }
}
</style>

<style lang="scss">
/* 与 leftTableChart.vue 中 .left-chart-1 的 tabs1 规则一致，保证右侧「全部/一年…」视觉对齐左侧 Tab */
.right-chart-1 {
  .el-tabs__nav-wrap::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: transparent;
    z-index: 1;
  }

  .tabs1 .el-tabs__header {
    margin: 0;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .tabs1 .el-tabs__nav-wrap {
    min-height: 0;
    display: flex;
    justify-content: center;
  }

  .tabs1 .el-tabs__item {
    height: 30px;
    line-height: 30px;
    margin-top: 2px;
    margin-bottom: 0;
    padding: 0 6px;
    font-size: 13px;
    max-width: none;
    white-space: nowrap;
  }

  .el-tabs__nav {
    padding-right: 4px;
  }

  .el-tabs__nav-next,
  .el-tabs__nav-prev {
    line-height: 34px;
    height: 34px;
    color: #b1b2b4;
    font-size: 16px;
  }

  .el-tabs__item {
    color: #ccc !important;
    text-align: center;
  }

  .is-active {
    color: #fff !important;
    font-weight: bold !important;
  }

  .el-tabs__active-bar {
    height: 2px !important;
    background-color: rgba(96, 252, 178, 1) !important;
  }
}
</style>
